

module.exports = __webpack_require__.stylable.create(
    "Quantity4071813384",
    {"classes":{"root":"Quantity4071813384__root","quantity":"Quantity4071813384__quantity","popover":"Quantity4071813384__popover"},"vars":{},"stVars":{"PopoverBackgroundColor":"#d6453d","textColor":"'\"color(--cart_textColor)\"'","bodyFont":"'\"font({theme: 'cart_textFontStyle', size: '12px', lineHeight: '1'})\"'","backgroundColor":"'\"color(--cart_background)\"'","disabledColor":"#C7C7C7"},"keyframes":{}},
    "",
    9,
    "Quantity4071813384",
    null
);
